import React from 'react';
import { withRouter } from "react-router-dom";
import { Row, Col, Button} from 'react-bootstrap'
import DeleteIcon from '../../../Assets/Icons/DeleteIcon.png'
import EditIcon from '../../../Assets/Icons/EditIcon.png'
import FullScreenModal from '../../FullScreenModal/FullScreenModal'
import Teacher from '../../../Models/Teacher';

import {AuthContext} from '../../../Helpers/auth/auth'
// onDeleteTeacher, teacher
class TeacherListItem extends React.Component { 
    constructor(props) {
        super(props)
        this.state = {
            showDeleteModal : false
        }
        this.teacherApi = new Teacher();
    }
    deleteTeacher() {
        var teacherId = this.props.teacher.idteacher
        var onDelete = this.props.onDeleteTeacher
        this.teacherApi.DeleteTeacher(teacherId, (success,err) => {
            if (success) {
                this.props.setMessages([{type : "success", message : `You have deleted teacher ${this.props.teacher.firstName} ${this.props.teacher.lastName}`}])
            } else {
                this.props.setMessages([{type : "danger", message : `You have failed to delete teacher ${this.props.teacher.firstName} ${this.props.teacher.lastName}`}])
            }
            if (onDelete && {}.toString.call(onDelete) === '[object Function]') {
                onDelete()
            }
        })
    }
    renderModal() {
        return (
            <FullScreenModal show={this.state.showDeleteModal} onClose={()=>{this.setState({showDeleteModal : false})}}>
                <Row>
                    <Col>
                        <div style={{padding : "20px"}}>
                            Confirm Delete {this.props.teacher.firstName} {this.props.teacher.lastName} ?
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div style={{padding : "10px", textAlign : "right"}}>
                            <Button 
                                variant = "secondary"
                                style={{marginRight : "30px"}}
                                onClick={() => {this.setState({showDeleteModal : false})}}>Cancel</Button>
                            <Button 
                                variant = "danger"
                                onClick={() => {this.deleteTeacher()}}>Delete</Button>
                        </div>
                    </Col>
                </Row>
            </FullScreenModal>
        )
    }
    render() {
        var teacher = this.props.teacher
        return (
            <>
            <Row style={{boxShadow : "3px 3px #CCCCCC", borderRadius : "15px", border : "1px solid #c0c0c0", ...this.props.style}}>
                <Col>
                    <Row className = "clickable" >
                        <Col xs={9} onClick={() => {
                            this.props.history.push(`/teacher/profile/${teacher.idteacher}`)
                        }}>
                            <div style={{textAlign : "left", padding : "10px"}}>
                                {teacher.firstName} {teacher.lastName}
                            </div>
                        </Col>
                        <Col xs={3} style={{textAlign : "right", display: "flex", alignItems: "center"}}>
                            <div style={{marginLeft : "auto"}}>
                                <img className = "clickable clickemphasis" src={EditIcon} style={{marginRight : "10px"}} onClick={() => {
                                    this.props.history.push(`/teacher/profile/${teacher.idteacher}`)
                                }}/>
                                {
                                   false && 
                                        (<img className = "clickable clickemphasis" src={DeleteIcon} onClick={()=>{
                                            this.setState({showDeleteModal : true})
                                        }}/>)
                                }
                                
                            </div>
                        </Col>   
                    </Row>
                </Col>
            </Row>
            {this.renderModal()}
            </>
        )
    }
}
// use context here
class TeacherListItemWrapper extends React.Component {
    render() {
        return (
            <AuthContext.Consumer>
                { ({isAuthenticated, setAuthenticated, user}) => (
                <TeacherListItem user={user} history={this.props.history} {...this.props}></TeacherListItem>)
                }
            </AuthContext.Consumer>
        )
    }
}
export default withRouter(TeacherListItemWrapper);